import { render, staticRenderFns } from "./DeliveryBy.vue?vue&type=template&id=02d84673&scoped=true&"
import script from "./DeliveryBy.vue?vue&type=script&lang=js&"
export * from "./DeliveryBy.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryBy.vue?vue&type=style&index=0&id=02d84673&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d84673",
  null
  
)

export default component.exports